// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"017a2c54","1328":"f4fd2d74","4974":"f6f3bdf6","6546":"8ae8652b","6729":"574fdf5d"}[chunkId] + ".chunk.css";
};